import React from "react";
import AsyncJsonLoader from "../auth/AsyncJsonLoader";
import CommentInfo from "./CommentInfo";

/*
 Загружает комментарий с сервера и рендерит элемент с ним
*/
export default function CommentLoader({commentId}) {
  return <AsyncJsonLoader path={"/api/comments/"+commentId+""} render={(comment)=>{
    return (
      <div className="container">
        <CommentInfo comment = {comment}/>
      </div>)
    }
  }/>
}